import { InsuranceNames } from "../enums/insurance-names.enum";
import { OrganizationNames } from "../enums/organization-names.enum";
import {
  DataHiddenConfig,
  ReportDataHiddenConfig,
} from "../models/hidden-data.models";

export const DATA_HIDDEN_CONFIG: DataHiddenConfig = {
  PROVIDER_NETWORK: {
    organizations: [
      OrganizationNames.LibertyDental,
      OrganizationNames.KareMobile,
      OrganizationNames.Aetna,
      OrganizationNames.Villagecare,
      OrganizationNames.Teledentists,
      OrganizationNames.Beanstalk,
      OrganizationNames.Lantnerdds,
      OrganizationNames.DentalSavers,
      OrganizationNames.OralLink,
      OrganizationNames.UCA,
      OrganizationNames.AsiaMedic,
    ],
    insurances: [],
  },
  TALK_TO_A_DENTIST: {
    organizations: [
      OrganizationNames.Lantnerdds,
      OrganizationNames.DentalSavers,
      OrganizationNames.OralLink,
      OrganizationNames.UCA,
      OrganizationNames.AsiaMedic,
    ],
    insurances: [],
  },
  PRODUCT_RECOMMENDATIONS: {
    organizations: [
      OrganizationNames.Aetna,
      OrganizationNames.OralLink,
      OrganizationNames.AsiaMedic,
    ],
    insurances: [],
  },
  DENTAL_ADVISOR: {
    organizations: [
      OrganizationNames.Aetna,
      OrganizationNames.OralLink,
      OrganizationNames.AsiaMedic,
    ],
    insurances: [],
  },
  ASSISTANT_PANEL: {
    organizations: [OrganizationNames.OralLink, OrganizationNames.AsiaMedic],
    insurances: [],
  },
  TREATMENT_VERIFICATION: {
    organizations: [
      OrganizationNames.Lantnerdds,
      OrganizationNames.DentalSavers,
      OrganizationNames.OralLink,
      OrganizationNames.AsiaMedic,
    ],
    insurances: [],
  },
  PHOTO_SCAN_INTAKE_FORM: {
    organizations: [OrganizationNames.OralLink, OrganizationNames.AsiaMedic],
    insurances: [],
  },
  PHOTO_SCAN_INTAKE_FORM_MODAL: {
    organizations: [OrganizationNames.DentalSavers],
    insurances: [],
  },
  INSURANCE: {
    organizations: [
      OrganizationNames.DentalSavers,
      OrganizationNames.OralLink,
      OrganizationNames.AsiaMedic,
    ],
    insurances: [],
  },
  VIEW_REPORTS: {
    organizations: [],
    insurances: [],
  },
  CUSTOMER_SERVICE_SUPPORT: {
    organizations: [OrganizationNames.DentalSavers],
    insurances: [],
  },
  ONBOARDING: {
    EXPLORE_PREMIUM: {
      organizations: [OrganizationNames.DentalSavers],
      insurances: [],
    },
  },
  UPGRADE_PLAN: {
    MONTHLY: {
      organizations: [],
      insurances: [],
    },
    ANNUAL: {
      organizations: [],
      insurances: [],
    },
  },
};

export const XRAY_REPORT_DATA_HIDDEN_CONFIG: ReportDataHiddenConfig = {
  ESTIMATED_COSTS: {
    organizations: [
      OrganizationNames.LibertyDental,
      OrganizationNames.Villagecare,
      OrganizationNames.KareMobile,
      OrganizationNames.OralLink,
      OrganizationNames.AsiaMedic,
    ],
    insurances: [InsuranceNames.LibertyDental],
  },
  PROVIDER_NETWORK: {
    organizations: [
      OrganizationNames.LibertyDental,
      OrganizationNames.KareMobile,
      OrganizationNames.Aetna,
      OrganizationNames.Villagecare,
      OrganizationNames.Teledentists,
      OrganizationNames.Beanstalk,
      OrganizationNames.Lantnerdds,
      OrganizationNames.DentalSavers,
      OrganizationNames.OralLink,
      OrganizationNames.UCA,
      OrganizationNames.AsiaMedic,
    ],
    insurances: [],
  },
  POTENTIAL_ACTIONS: {
    organizations: [
      OrganizationNames.LibertyDental,
      OrganizationNames.Villagecare,
    ],
    insurances: [InsuranceNames.LibertyDental],
  },
  PRODUCT_RECOMMENDATIONS: {
    organizations: [
      OrganizationNames.Aetna,
      OrganizationNames.OralLink,
      OrganizationNames.AsiaMedic,
    ],
    insurances: [],
  },
  FINDING_CATEGORY: {
    organizations: [],
    insurances: [],
  },
};

export const PHOTO_REPORT_DATA_HIDDEN_CONFIG: ReportDataHiddenConfig = {
  ESTIMATED_COSTS: {
    organizations: [
      OrganizationNames.LibertyDental,
      OrganizationNames.Villagecare,
      OrganizationNames.KareMobile,
      OrganizationNames.OralLink,
      OrganizationNames.AsiaMedic,
    ],
    insurances: [InsuranceNames.LibertyDental],
  },
  PROVIDER_NETWORK: {
    organizations: [
      OrganizationNames.LibertyDental,
      OrganizationNames.KareMobile,
      OrganizationNames.Aetna,
      OrganizationNames.Villagecare,
      OrganizationNames.Teledentists,
      OrganizationNames.Beanstalk,
      OrganizationNames.Lantnerdds,
      OrganizationNames.DentalSavers,
      OrganizationNames.OralLink,
      OrganizationNames.UCA,
      OrganizationNames.AsiaMedic,
    ],
    insurances: [],
  },
  POTENTIAL_ACTIONS: {
    organizations: [
      OrganizationNames.LibertyDental,
      OrganizationNames.Villagecare,
      OrganizationNames.DentalSavers,
    ],
    insurances: [InsuranceNames.LibertyDental],
  },
  PRODUCT_RECOMMENDATIONS: {
    organizations: [
      OrganizationNames.Aetna,
      OrganizationNames.OralLink,
      OrganizationNames.AsiaMedic,
    ],
    insurances: [],
  },
  FINDING_CATEGORY: {
    organizations: [OrganizationNames.DentalSavers],
    insurances: [],
  },
};

export const getReportDataHiddenConfig = (isXrayReport: boolean) =>
  isXrayReport
    ? XRAY_REPORT_DATA_HIDDEN_CONFIG
    : PHOTO_REPORT_DATA_HIDDEN_CONFIG;
